import DOMPurify from "dompurify";

// Minimal allow-list for content typed by admin (owner-trusted).
const ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "u", "a", "ul", "ol", "li", "span", "h3", "h4"];
const ALLOWED_ATTR = ["href", "target", "rel"];

export function sanitizeHtml(dirty) {
  if (!dirty) return "";
  return DOMPurify.sanitize(String(dirty), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // ensure target=_blank on links has safe rel
    ADD_ATTR: ["target", "rel"],
  });
}

/**
 * Detects whether the given string contains any HTML-like tag content.
 * Used to decide between plain-text + whitespace-pre-line rendering
 * vs dangerouslySetInnerHTML rendering.
 */
export function looksLikeHtml(str) {
  if (!str || typeof str !== "string") return false;
  return /<\w+[^>]*>/.test(str);
}
